import { render, staticRenderFns } from "./CertificateStatusBadge.vue?vue&type=template&id=6b6b5622&scoped=true"
import script from "./CertificateStatusBadge.vue?vue&type=script&lang=ts"
export * from "./CertificateStatusBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b5622",
  null
  
)

export default component.exports